import {
  CurrencySchema,
  PriceBookEntrySchema,
} from "@redotech/redo-inventory-common/price-book/price-book";
import { priceBookIdFormat } from "@redotech/redo-marketplace-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const createPriceBookEntry = unaryRpc({
  name: "createPriceBookEntry" as const,
  input: z.object({
    priceBookId: priceBookIdFormat.schema,
    productId: productIdFormat.schema,
    fixedPrice: z.bigint().nullable().optional(),
    currency: CurrencySchema.nullable().optional(),
    kind: z.string().optional(),
  }),
  output: z.object({ entry: PriceBookEntrySchema }),
});
